module.exports = "/images/avatar-s-22.jpg?4ec94f65155c185b8756afa2bd093770";